import styled from '@emotion/styled'
import { ExtranetCustomerListItemDto } from '@pharmac-extranet/extranet-api'
import {
  ExtranetModal,
  ExtranetModalBody,
  ExtranetModalHeader,
  ExtranetTable,
  ExtranetTableColumn,
  ExtranetTableRow,
  useLanguage,
} from '@pharmac-extranet/shared'
import { PharmacIcon, PharmacText } from '@pharmac/ui'
import { useAuthenticationContext } from '../../features/authentication/useAuthentication'
import { useCustomerContext } from '../../features/customer/CustomerProvider'

const SelectCustomerModalCustomersList = styled.div`
  margin: var(--spacing-large) 0;

  .entable__row {
    &:hover {
      background-color: var(--extranet-light-purple);
      .entable__column {
        color: var(--color-primary);
      }
    }

    .entable__column {
      font-family: var(--font-family-secondary);

      svg {
        transform: translateY(1px);
      }
    }
  }
`

export const SelectCustomerModal = () => {
  const context = useCustomerContext()
  const { user, hasInitialized: authInitialized } = useAuthenticationContext()
  const { t } = useLanguage()

  const handleSelectCustomer = (customer: ExtranetCustomerListItemDto | false) => {
    context.setCustomer(customer)
  }

  if (!context.hasInitialized || !authInitialized) {
    return null
  }

  return (
    <ExtranetModal preventClose>
      <ExtranetModalHeader style={{ color: 'var(--color-primary)' }}>
        {t('common:greeting')} {user?.firstName}!
      </ExtranetModalHeader>
      <ExtranetModalBody>
        <PharmacText className="choose-customer-text">{t('common:chooseCustomer')}</PharmacText>
        <SelectCustomerModalCustomersList>
          <ExtranetTable>
            {context.userCustomers.map((customer) => (
              <ExtranetTableRow
                key={customer.id}
                onClick={() => handleSelectCustomer(customer)}
              >
                <ExtranetTableColumn
                  size={1}
                  flexJustify="center"
                  style={{ minWidth: 'calc(var(--spacing-medium) + 24px)' }}
                >
                  <PharmacIcon icon="home" />
                </ExtranetTableColumn>
                <ExtranetTableColumn size={10}>{customer.name}</ExtranetTableColumn>
              </ExtranetTableRow>
            ))}
          </ExtranetTable>
        </SelectCustomerModalCustomersList>
      </ExtranetModalBody>
    </ExtranetModal>
  )
}
